import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const roleInit = {
  roles: {},
  isLoadingRoles: false,
};

function rolesReducer(draft, { type, payload }) {
  switch (type) {
    case "setRoles": {
      payload.Roles.forEach(role => draft.roles[[role.id]] = role)
      break;
    }

    case "setIsLoadingRoles": {
      draft.isLoadingRoles = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [RoleContext, RoleDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function RoleProvider({ children }) {
  const [roleStore, dispatch] = useImmerReducer(rolesReducer, roleInit);

  return (
    <RoleContext.Provider value={roleStore}>
      <RoleDispatchContext.Provider value={dispatch}>
        {children}
      </RoleDispatchContext.Provider>
    </RoleContext.Provider>
  );
}

export function useRoleStore() {
  return useContext(RoleContext);
}

export function useRoleDispatch() {
  return useContext(RoleDispatchContext);
}